import { defineMessages } from 'react-intl';

export default defineMessages({
  allAvailablePractitionersAndEquipment: {
    id: 'appointments.calendar-links.all-available-practitioners-and-equipment',
    defaultMessage: '<strong>{venueName}</strong> (all available practitioners and equipment)',
  },
  title: {
    id: 'appointments.calendar-links.title',
    defaultMessage: 'Calendar Sync',
  },
  buttonBack: {
    id: 'appointments.calendar-links.button-back',
    defaultMessage: 'Appointments',
  },
  buttonSave: {
    id: 'appointments.calendar-links.button-save',
    defaultMessage: 'Save',
  },
  buttonRemove: {
    id: 'appointments.calendar-links.button-remove',
    defaultMessage: 'Remove',
  },
  exportUrlModalTitle: {
    id: 'appointments.calendar-links.export-url-modal-title',
    defaultMessage: 'Copy link to share your ClassPass calendar',
  },
  exportUrlModalBody: {
    id: 'appointments.calendar-links.export-url-modal-body',
    defaultMessage:
      'By copying the below URL you can share your CP calendar with Outlook, Apple iCal or any other calendar/booking platform that supports CalendarSync.',
  },
  exportUrlModalCancel: {
    id: 'appointments.calendar-links.export-url-modal-cancel',
    defaultMessage: 'Cancel',
  },
  exportUrlModalCopy: {
    id: 'appointments.calendar-links.export-url-modal-copy',
    defaultMessage: 'Copy & Close',
  },
  importUrlTooltip: {
    id: 'appointments.calendar-links.import-url-tooltip',
    defaultMessage: 'Provide a unique URL for your practitioner/equipment to import their external calendar',
  },
  exportLinkTooltip: {
    id: 'appointments.calendar-links.export-link-tooltip',
    defaultMessage:
      'Click this link to generate a URL for this practitioner/equipment which can be used to export your CP appointments to your calendar app',
  },
  venueExportLinkTooltip: {
    id: 'appointments.calendar-links.venue-export-link-tooltip',
    defaultMessage:
      'Click this link to generate a URL for your venue which can be used to export all of your CP appointments to your calendar app',
  },
  noInstructors: {
    id: 'appointments.calendar-links.no-instructors',
    defaultMessage: 'There is no practitioners associated with this venue',
  },
  invalidLink: {
    id: 'appointments.calendar-links.invalid-link',
    defaultMessage:
      "It looks like you've entered a URL we're unable to reference for Calendar Sync. Your link should include terms like ical, webcal, export, api or ics. <a>Click here</a> to learn more.",
  },
  noWriteAccessToCalendar: {
    id: 'appointments.calendar-links.no-write-access-to-calendar',
    defaultMessage: 'You no longer have write access to this calendar',
  },
  sagaSaveSuccess: {
    id: 'appointments.calendar-links.saga-save-success',
    defaultMessage: 'Your calendars links have been saved',
  },
  sagaDeleteSuccess: {
    id: 'appointments.calendar-links.saga-delete-success',
    defaultMessage: 'Your calendar link has been successfully deleted',
  },
  sagaCopyLinkSuccess: {
    id: 'appointments.calendar-links.saga-copy-link-success',
    defaultMessage: 'The link has been saved to clipboard',
  },
  sagaError: {
    id: 'appointments.calendar-links.saga-error',
    defaultMessage: 'There was a problem with your request',
  },
  addPractitionerLink: {
    id: 'appointments.calendar-links.add-practitioner-link',
    defaultMessage: 'Looking for a staff member you don’t see? Add them <a>here</a>',
  },
  availablePractitionersOrEquipment: {
    id: 'appointments.calendar-links.available-practitioners-or-equipment',
    defaultMessage: 'Available practitioners or equipment',
  },
  availablePractitionersOrEquipmentGcalSubtitle: {
    id: 'appointments.calendar-links.available-practitioners-or-equipment-gcal-subtitle',
    defaultMessage: 'Select a calendar to sync from for each practitioner or equipment.',
  },
  availablePractitionersOrEquipmentIcalSubtitle: {
    id: 'appointments.calendar-links.available-practitioners-or-equipment-ical-subtitle',
    defaultMessage: 'Add a schedule url to sync from for each practitioner or equipment.',
  },
  unavailablePractitionersOrEquipment: {
    id: 'appointments.calendar-links.unavailable-practitioners-or-equipment',
    defaultMessage: 'Unavailable practitioners or equipment',
  },
  unavailablePractitionersOrEquipmentSubtitle: {
    id: 'appointments.calendar-links.unavailable-practitioners-or-equipment-subtitle',
    defaultMessage:
      'Ensure your practitioners or equipment have a recurring schedule and Services associated to them in order to be bookable by ClassPass members.',
  },
  unavailablePractitionersOrEquipmentManageButton: {
    id: 'appointments.calendar-links.unavailable-practitioners-or-equipment-manage-button',
    defaultMessage: 'Manage Staff',
  },
  sagaReportPlatformNameSuccess: {
    id: 'appointments.calendar-links.saga-report-platform-name-success',
    defaultMessage: 'Thank you for providing your scheduling platform name.',
  },
  googleCalendarPlaceholder: {
    id: 'appointments.calendar-links.google-flow.dropdown-placeholder',
    defaultMessage: 'Select calendar to sync',
  },
  googleAuthError: {
    id: 'appointments.calendar-links.google-flow.google-auth-error',
    defaultMessage:
      'Unable to connect to your Google account. <a>Contact us</a> to reset and restart your Calendar Sync. You can also reset manually by clicking the reset button.',
  },
  googleAuthReset: {
    id: 'appointments.calendar-links.google-flow.google-auth-reset',
    defaultMessage: 'Reset',
  },
  lastSuccessfulSync: {
    id: 'appointments.calendar-links.last-successful-sync',
    defaultMessage: 'Last Sync: {syncDate, date, long-w-dow-time}',
  },
  shareCPCalendar: {
    id: 'appointments.calendar-links.share-cp-calendar',
    defaultMessage: 'Share CP Calendar',
  },
  wrongPlatformError: {
    id: 'appointments.calendar-links.wrong-platform-error',
    defaultMessage:
      'It looks like you’ve inputted your export URL from CP - please provide an import link from your external calendar application such as Apple calendar or your booking platform',
  },
});

export const ctaMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.cta.title',
    defaultMessage: 'Make reservation management quick and effortless with <emphasis>Calendar Sync</emphasis>',
  },
  copy: {
    id: 'appointments.calendar-links.cta.copy',
    defaultMessage:
      'When you use Calendar Sync, ClassPass will automatically block off availability from your booking software to avoid over booking. <bold>Start by selecting the platform you use to schedule appointments.</bold>',
  },
  button: {
    id: 'appointments.calendar-links.cta.button',
    defaultMessage: 'Get started',
  },
  selectPlatform: {
    id: 'appointments.calendar-links.cta.select-platform',
    defaultMessage: 'Select your scheduling platform',
  },
});

export const platformNotSupportedModalMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.platform-not-supported-modal.title',
    defaultMessage: 'Selected platform is not supported yet.',
  },
  continue: {
    id: 'appointments.calendar-links.platform-not-supported-modal.continue',
    defaultMessage: 'Continue',
  },
  body: {
    id: 'appointments.calendar-links.platform-not-supported-modal.body',
    defaultMessage: 'Your scheduling platform integration with Calendar Sync is not currently supported.',
  },
});

export const notListedPlatformModalMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.not-listed-platform-modal.title',
    defaultMessage: 'Scheduling platform not supported',
  },
  platformNameLabel: {
    id: 'appointments.calendar-links.not-listed-platform-modal.platform-name-label',
    defaultMessage: 'Please provide your scheduling platform name',
  },
  submit: {
    id: 'appointments.calendar-links.not-listed-platform-modal.submit',
    defaultMessage: 'Submit',
  },
  cancel: {
    id: 'appointments.calendar-links.not-listed-platform-modal.cancel',
    defaultMessage: 'Cancel',
  },
});

export const resetCalendarSyncFlowModalMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.reset-calendar-sync-flow-modal.title',
    defaultMessage: 'Switch to Another Platform?',
  },
  body: {
    id: 'appointments.calendar-links.reset-calendar-sync-flow-modal.body',
    defaultMessage:
      'Are you sure you would like to switch platforms? This will reset your existing Calendar Sync and remove all synced events.',
  },
  cancel: {
    id: 'appointments.calendar-links.reset-calendar-sync-flow-modal.cancel',
    defaultMessage: 'No, thanks',
  },
  accept: {
    id: 'appointments.calendar-links.reset-calendar-sync-flow-modal.accept',
    defaultMessage: 'Switch',
  },
});

export const learnMoreCtaMessages = defineMessages({
  copy: {
    id: 'appointments.calendar-links.learn-more-cta.copy',
    defaultMessage: 'Prevent double booking by transferring your calendar events to ClassPass.',
  },
  button: {
    id: 'appointments.calendar-links.learn-more-cta.button',
    defaultMessage: 'Learn more',
  },
});

export const learnMoreBannerMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.learn-more-banner.title',
    defaultMessage: 'Automatically block off availability',
  },
  subtitle: {
    id: 'appointments.calendar-links.learn-more-banner.subtitle',
    defaultMessage:
      'Prevent double booking by transferring your calendar events to ClassPass. <tutorialLink>View tutorial</tutorialLink>',
  },
  button: {
    id: 'appointments.calendar-links.learn-more-banner.button',
    defaultMessage: 'Learn more',
  },
});

export const yourPlatformMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.your-platform.copy',
    defaultMessage: 'YOUR PLATFORM',
  },
  learnHow: {
    id: 'appointments.calendar-links.your-platform.learn-how',
    defaultMessage: 'Learn how to sync your platform',
  },
  icalNote: {
    id: 'appointments.calendar-links.your-platform.ical-note',
    defaultMessage: '<strong>Important:</strong> Each staff or equipment will require a URL to sync from.',
  },
  gcalNote: {
    id: 'appointments.calendar-links.your-platform.gcal-note',
    defaultMessage: '<strong>Important:</strong> Make sure your scheduling platform is synced with Google Calendar.',
  },
  edit: {
    id: 'appointments.calendar-links.your-platform.edit',
    defaultMessage: 'Edit',
  },
  switchToAnotherPlatform: {
    id: 'appointments.calendar-links.switch-to-another-platform',
    defaultMessage: 'Reset or switch your platform',
  },
  thingsToKnowAbout: {
    id: 'appointments.calendar-links.things-to-know-about-syncing',
    defaultMessage: 'Things to know about syncing with {platformName}:',
  },
});

export const changeGoogleAccountModalMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.change-google-account-modal.title',
    defaultMessage: "Are you sure you'd like to switch accounts?",
  },
  body: {
    id: 'appointments.calendar-links.change-google-account-modal.body',
    defaultMessage: 'This will reset your existing Calendar Sync and remove all synced events.',
  },
  cancel: {
    id: 'appointments.calendar-links.change-google-account-modal.cancel',
    defaultMessage: 'No',
  },
  accept: {
    id: 'appointments.calendar-links.change-google-account-modal.accept',
    defaultMessage: 'Yes',
  },
});

export const deleteCalendarConfirmationModalMessages = defineMessages({
  title: {
    id: 'appointments.calendar-links.delete-calendar-confirmation-modal.title',
    defaultMessage: 'Are you sure?',
  },
  body: {
    id: 'appointments.calendar-links.delete-calendar-confirmation-modal.body',
    defaultMessage:
      'This will disconnect your practitioner from CalendarSync and remove any blocks created by your Calendar source.',
  },
  cancel: {
    id: 'appointments.calendar-links.delete-calendar-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  accept: {
    id: 'appointments.calendar-links.delete-calendar-confirmation-modal.accept',
    defaultMessage: 'Continue',
  },
});
